import { useTokenReadContract } from '../contracts/useTokenReadContract'

export const useTokenSymbol = () => {
  const { data = DEFAULT_TOKEN_SYMBOL, ...query } = useTokenReadContract('symbol', [])

  return {
    data: `${data}`,
    ...query,
  }
}

export const DEFAULT_TOKEN_SYMBOL = 'USDC'
